import React from 'react';
import './BlinkingDots.css';  // You can define the CSS here

const BlinkingDots = () => {
  return (
    <span className="blinking-dots">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  );
};

export default BlinkingDots;